import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "../../../Intl";
import isEmpty from "lodash/isEmpty";
import Subscription from '../Subscription';

import { subscribeEmail } from "@s7ui-kit/s7ui-kit/build/index";
import {connect} from "react-redux";

const mapStateToProps = state => {
    return {
        lang: state.App.lang,
    };
};

class NewsSubscription extends Component {
    componentDidMount() {
        const { words, getMessage } = this.props;

        getMessage(words, 'com.s7.component.subscription.price.main.text');
        getMessage(words, 'com.s7.component.subscription.price.main.title');
    }

    onSubmit = emailValue => {
       const { lang } = this.props;
       return subscribeEmail(emailValue, lang);
    };

    render() {
        const { btnCssClasses, cssClasses, text, title, gaFrom, confirmCheckbox, titleLevel, words, getMessage, gaCategory, fullSize, compact } = this.props;

        return (
            <Subscription
                text={isEmpty(text) ? getMessage(words, 'com.s7.component.subscription.main.text'): text}
                title={isEmpty(title) ? getMessage(words, 'com.s7.subscription.block.title'): title}
                cssClasses={cssClasses}
                btnCssClasses={btnCssClasses}
                confirmCheckbox={confirmCheckbox}
                titleLevel={titleLevel}
                onSubmit={this.onSubmit}
                gaCategory={gaCategory}
                gaFrom={gaFrom}
                fullSize={fullSize}
                compact={compact}
                dataTest='news-subscription'
            />
        );
    };
}

NewsSubscription.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    cssClasses: PropTypes.string,
    btnCssClasses:  PropTypes.string,
    confirmCheckbox: PropTypes.bool,
    gaFrom: PropTypes.string,
    gaCategory: PropTypes.string,
    titleLevel: PropTypes.number,
    fullSize: PropTypes.bool,
    compact: PropTypes.bool
};

NewsSubscription.defaultProps = {
    text: '',
    title: '',
    cssClasses: '',
    btnCssClasses: '',
    agree: false,
    titleLevel: 3,
    confirmCheckbox: false,
    gaCategory: 'Portal_NewsSubscribe',
    fullSize: false,
    compact: false
};

export default (injectIntl(connect(mapStateToProps)(NewsSubscription)));